import StateIcon from '@material-ui/icons/TurnedIn';
import StateList from './StateList';
import StateCreate from './StateCreate';
import StateEdit from './StateEdit';
const StateModule = {
    list: StateList,
    icon: StateIcon,
    create: StateCreate,
    edit: StateEdit,
}; export default StateModule;